import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {Milestone} from './milestone'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickerSearchUrl} from '@github-ui/item-picker-base/api/urls'
import {SearchMilestones} from '@github-ui/server-persisted-queries'

/**
 * The types here align with the query made on the server defined here:
 * https://github.com/github/github/blob/master/app/controllers/ghui/item_pickers/milestones_controller.rb#L24
 * If the shape of that response changes, this type should be
 * updated to reflect any modified fields
 */

export type GetSearchMilestonesRequest = {
  owner: string
  repo: string
  query?: string
  count?: number
}

type GetSearchMilestonesResponseData = {
  repository: {
    id: string
    milestones: {
      nodes: Milestone[]
    }
  }
}

export type GetSearchMilestonesResponse = GraphQLResponse<GetSearchMilestonesResponseData>

export async function apiGetSearchMilestones({
  owner,
  repo,
  query,
  count,
}: GetSearchMilestonesRequest): Promise<GetSearchMilestonesResponse> {
  const params: Record<string, unknown> = {owner, repo, queryId: SearchMilestones}

  if (query) {
    params['query'] = query
  }

  if (count) {
    params['count'] = count
  }

  const requestUrl = buildItemPickerSearchUrl('milestones', params)
  const request = await verifiedFetchJSON(requestUrl)
  return (await request.json()) as GetSearchMilestonesResponse
}

const itemPickerQueryKeyBase = 'item_picker'

export function buildMilestonePickerSearchQueryKey(searchParams: GetSearchMilestonesRequest) {
  return [itemPickerQueryKeyBase, 'milestones', searchParams]
}

export type MilestonePickerQueryData = {
  repositoryId: string
  milestones: Milestone[]
}

export function transformSearchMilestoneResponseToQueryData(
  response: GetSearchMilestonesResponseData,
): MilestonePickerQueryData {
  return {
    milestones: response.repository.milestones.nodes,
    repositoryId: response.repository.id,
  }
}
